import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import FullSite from "./full-site";

import CashoutService from "../../../services/cashout";

import * as C from "../desktop-templates/cashout.jsx";
import * as T from "../mobile-templates/tournament.jsx";
import { route } from "preact-router";
import { AngleDown, CircleCheck, CircleXmark, LockIcon, PrinterIcon, SlidersIcon } from "../utils/icons.jsx";
import User from "../../../services/user";
import formatOdd from "../../../services/odds-format";
import MoneyFormatter from "../utils/money-formatter.jsx";
import { CashoutOptionsContent, CashoutOptionsTooltip } from "../desktop-components/autocashout-tooltip.jsx";
import Config from "../config.jsx";
import Ticket from "../../../services/ticket";
import PageDataFeed from "../../../services/page-data-feed";

export default function Cashout(props) {
	return <FullSite><CashoutPage {...props} /></FullSite>
}

export class CashoutPage extends Component {
	render({ onCloseCallback }) {
		return <div>
			<T.TournamentHeader
				sport={{ name: 'My Bets' }}
				category={{ name: "Cashout" }}
				onClose={!!onCloseCallback ? () => { onCloseCallback() } : () => { window.history.back() }}
			/>
			<CashoutComponent />
		</div>
	}
}


export class CashoutComponent extends Component {
	render() {
		return <C.CashoutContents>
			<C.MobileCashoutFiltersRow>
				<C.MobileCashoutFilterButton active={true}><Trans>Open Bets</Trans></C.MobileCashoutFilterButton>
				<C.MobileCashoutFilterButton onClick={e => route("/user/tickets")}><Trans>History</Trans></C.MobileCashoutFilterButton>
			</C.MobileCashoutFiltersRow>
			<OpenTicketsList />
		</C.CashoutContents>
	}
}

export class OpenTicketsList extends Component {
	state = {
		bets: null
	}
	componentWillMount() {
		this.loadBets()
		this.handler = setInterval(() => {
			if (this.state.bets == null)
				return;
			const liveTickets = this.state.bets.filter(t => t.live);
			if (liveTickets)
				CashoutService.fetchCurrentOddsForLiveTickets(liveTickets).then(r => this.setState({}))

			const prematchTickets = this.state.bets.filter(t => !t.live);
			if (prematchTickets)
				CashoutService.fetchCurrentOddsForPrematchTickets(prematchTickets).then(r => this.setState({}))
		}, 3e3)
	}
	componentWillUnmount() {
		clearInterval(this.handler)
	}
	loadBets = () => {
		CashoutService.fetchOpenBets().then(bets => {
			this.setState({ bets: bets })
		})
	}
	render() {
		const bets = this.state.bets && this.state.bets.filter(ticket => User.data && ticket.player == User.data.id)
		return <div class="w-full bg-slate-800 rounded-lg overflow-hidden">
			<div class="hidden w-full bg-slate-900 p-2 uppercase text-slate-100"><span>Cashout</span></div>
			<C.CashoutTicketsContainer>
				{this.state.bets && this.state.bets.length > 0
					? this.state.bets.map(ticket => <TicketElement ticket={ticket} onCashout={e => this.loadBets()} />)
					: <C.CashoutEmptyStatus />}
			</C.CashoutTicketsContainer></div>
	}
}

export class TicketElement extends Component {
	state = {
		closed: true,
		showCashoutOptions: false
	};

	isPending(ticket) {
		return ticket.status == 'N';
	}

	cashoutTicket(ticket, expectedWin) {
		if (!window.confirm("Do you want to cashout this ticket?"))
			return;
		CashoutService.doCashout(ticket, expectedWin).then((cashoutResult) => {
			this.setState({})
			this.props.onCashout()
			alert("Cashout successful")
		})
	}
	cashoutTicketHandler = () => {
		this.cashoutTicket(this.props.ticket, CashoutService.calculateCashoutWin(this.props.ticket))
	}

	toggleCashoutOptions = () => {
		this.setState({ showCashoutOptions: !this.state.showCashoutOptions, closed: !this.state.showCashoutOptions });
	}

	toggleOpen() {
		return this.setState({ closed: !this.state.closed });
	}

	render({ ticket, onCashout }, { closed, showCashoutOptions }) {
		return <C.Ticket>
			<C.TicketHeader onClick={e => this.toggleOpen()}>
				<C.TicketType>{ticket.id}</C.TicketType>
				<div class="flex items-center gap-2">
					<div class="" onClick={e => PageDataFeed.printTicket({ code: ticket.ticketId })}><PrinterIcon class="h-4" /></div>
					<div class="">{ticket.live ? <Trans>Live</Trans> : <Trans>Prematch</Trans>}</div>
					<C.TicketPrintBtn>
						<AngleDown class={"h-4 transition-transform " + (closed ? "rotate-180" : "")} />
					</C.TicketPrintBtn>
				</div>
			</C.TicketHeader>
			{closed ? null : <C.TicketSelections>
				{ticket.odds.map(outcome => <Outcome outcome={outcome} currentOdds={CashoutService.getUpdatedOdd(outcome.id)} />)}
			</C.TicketSelections>}
			<C.TicketPriceInfo>
				<div class="flex flex-col gap-1 w-1/2">
					<C.TicketPrice>
						<C.TicketPriceLabel><Trans>Stake</Trans></C.TicketPriceLabel>
						<C.TicketPriceValue><MoneyFormatter value={ticket.betAmount} currency={ticket.currency} /></C.TicketPriceValue>
					</C.TicketPrice>
					{this.isPending(ticket) ? <C.TicketMaxWin>
						<C.TicketPriceLabel><Trans>Max Win</Trans></C.TicketPriceLabel>
						<C.TicketPriceValue><MoneyFormatter value={ticket.maxWinAmount} currency={ticket.currency} /></C.TicketPriceValue>
					</C.TicketMaxWin> : <C.TicketMaxWin>
						<C.TicketPriceLabel><Trans>Win</Trans></C.TicketPriceLabel>
						<C.TicketPriceValue><MoneyFormatter value={ticket.winAmount} currency={ticket.currency} /></C.TicketPriceValue>
					</C.TicketMaxWin>}
				</div>
				<div class="w-1/2 flex items-stretch justify-end pl-2">
					{this.isPending(ticket) ?
						<ExtendedCashoutButton
							ticket={ticket}
							cashoutTicketHandler={this.cashoutTicketHandler}
							cashoutWinAmount={CashoutService.calculateCashoutWin(ticket)}
							toggleCashoutOptions={this.toggleCashoutOptions}
						/>
						: <StatusBadge ticket={ticket} />}
				</div>
			</C.TicketPriceInfo>
			{showCashoutOptions && <div class="bg-white">
				<CashoutOptionsContent
					row={ticket}
					ticket={ticket}
					onClose={() => this.setState({ showCashoutOptions: false })}
					onAutoCashout={onCashout}
					onPartialCashout={onCashout}
				/>
			</div>}
		</C.Ticket>
	}
}

export function ExtendedCashoutButton({ ticket, cashoutTicketHandler, cashoutWinAmount, toggleCashoutOptions }) {
	return <Fragment>
		<CashoutButton
			ticket={ticket}
			cashoutWinAmount={cashoutWinAmount}
			cashoutTicket={cashoutTicketHandler}
		/>
		<div class="rounded-r bg-kobaaccent-500 text-black font-bold flex items-center justify-center">
			{!!Config.partialcashout && ticket.betAmount >= Ticket.getMinBetAfterTax() && <a
				href="javascript:void(0)"
				class={"w-12 py-1 px-2 text-sm rounded leading-5 button-minimal flex flex-col items-center justify-center gap-1"}
				title={window.Translation(msg`Partial Cashout`)}
				onClick={toggleCashoutOptions}
			>
				<i class="fas fa-sliders-h" />
				{ticket.autocashout && <AutocashoutLabel />}
			</a>}
		</div>
	</Fragment>
}
export function CondensedCashoutButton({ ticket, cashoutTicketHandler, cashoutWinAmount, toggleCashoutOptions }) {
	return <Fragment>
		<div class="leading-none pt-0.5" onClick={cashoutTicketHandler}>
			<div class="uppercase text-xxs font-semibold"><Trans>Cashout</Trans></div>
			<div class="text-sm leading-none font-semibold">{cashoutWinAmount.toFixed(2)}</div>
		</div>
		{!!Config.partialcashout && ticket.betAmount >= Ticket.getMinBetAfterTax() &&
			<div class="flex items-center justify-center border-t border-kobaaccent-600 gap-1 grow h-full bg-kobaaccent-600/50 text-black"  onClick={toggleCashoutOptions}>
				<SlidersIcon class="h-3" />
				{ticket.autocashout && <AutocashoutLabel />}
			</div>
		}
	</Fragment>
}

export function AutocashoutLabel() {
	return <div class="flex-shrink-0">
		<div class="flex flex-col bg-red-600 text-white font-bold text-xxs uppercase text-center gap-1 rounded w-10 px-0.5 py-0">
			<span>Auto</span>
		</div>
	</div>;
}

export function CashoutButton({ ticket, cashoutWinAmount = CashoutService.calculateCashoutWin(ticket), cashoutTicket }) {
	return <div
		class="px-2 py-1 grow rounded-l bg-kobaaccent-500 border-r border-kobaaccent-600 text-black font-bold text-xs text-center cursor-pointer"
		onClick={e => cashoutTicket()}>
		<div class="uppercase"><Trans>Cashout</Trans></div>
		<div class="text-sm">{cashoutWinAmount.toFixed(2)} {ticket.currency}</div>
	</div>
}

export function Outcome({ outcome, currentOdds = CashoutService.getUpdatedOdd(outcome.id) }) {
	const showLiveOdds = outcome.date <= Date.now();

	return <C.TicketSelection>
		<C.TicketEvent>{outcome.name}</C.TicketEvent>
		<C.TicketTournament>{outcome.sport.name} / {outcome.category.name} / {outcome.tournament.name}</C.TicketTournament>
		<C.TicketDate>
			{new Date(outcome.date).toLocaleDateString([], { day: "numeric", month: "short" })}
			{" "}
			{new Date(outcome.date).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true })}
		</C.TicketDate>
		<C.TicketOutcome>
			<C.TicketOutcomeDescription>{outcome.market} - {outcome.outcome}</C.TicketOutcomeDescription>
			<C.TicketOutcomeLiveOdd>
				{!showLiveOdds ? null :
					currentOdds ? <div class="text-xs text-slate-700 flex gap-1 items-center">
						<div class="rounded-full bg-red-500 h-1 w-1">
							<div class="rounded-full bg-red-500 animate-ping h-2 w-2 relative -top-0.5 -left-0.5"></div>
						</div>
						{formatOdd(outcome.value)}
					</div> :
						<LockIcon class="h-3 text-slate-700" />
				}
			</C.TicketOutcomeLiveOdd>
			<C.TicketOutcomeOdd>{formatOdd(outcome.value)}</C.TicketOutcomeOdd>
			<C.TicketOutcomeStatusIcon>
				{outcome.status == 'win' ? <CircleCheck class="h-4 text-green-500" /> :
					outcome.status == 'lose' ? <CircleXmark class="h-4 text-red-500" /> :
						outcome.status == 'void' ? <Circle class="h-4 text-slate-500" /> :
							outcome.status == 'half-win' ? <CircleCheck class="h-4 text-slate-500" /> :
								outcome.status == 'half-lose' ? <CircleXmark class="h-4 text-slate-500" /> :
									null
				}
			</C.TicketOutcomeStatusIcon>
		</C.TicketOutcome>
	</C.TicketSelection>
}


// Facciamo che è un'enum
const STATUS_NAME = {
	V: msg`Win`,
	P: msg`Lose`,
	M: msg`To Pay`,
	N: msg`Pending`,
	C: msg`Rejected`,
	D: msg`User Rejected`,
	A: msg`Cancelled`,
	R: msg`Risk Management`,
	S: msg`Completed System`
};

export function StatusBadge({ ticket }) {
	if (ticket.status == 'V' || ticket.status == 'M' || ticket.status == 'S')
		return <div class="flex flex-col bg-green-600 text-white font-bold text-xs uppercase text-center gap-1 rounded px-2 py-1">
			{window.Translation(STATUS_NAME[ticket.status])}
		</div>;
	return <div class="flex flex-col bg-red-600 text-white font-bold text-xs uppercase text-center gap-1 rounded px-2 py-1">
		{window.Translation(STATUS_NAME[ticket.status])}
	</div>;
}
